"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _CreatePopulation = _interopRequireDefault(require("../model/CreatePopulation"));
var _CreateSavingsGuarantee = _interopRequireDefault(require("../model/CreateSavingsGuarantee"));
var _CreateSite = _interopRequireDefault(require("../model/CreateSite"));
var _UpdatePopulation = _interopRequireDefault(require("../model/UpdatePopulation"));
var _UpdateSavingsGuarantee = _interopRequireDefault(require("../model/UpdateSavingsGuarantee"));
var _UpdateSite = _interopRequireDefault(require("../model/UpdateSite"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
* Sites service.
* @module api/SitesApi
* @version 0.1.0
*/
var SitesApi = /*#__PURE__*/function () {
  /**
  * Constructs a new SitesApi. 
  * @alias module:api/SitesApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function SitesApi(apiClient) {
    _classCallCheck(this, SitesApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * @param {Number} id 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
   */
  _createClass(SitesApi, [{
    key: "callDeleteWithHttpInfo",
    value: function callDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling callDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "callDelete",
    value: function callDelete(id) {
      return this.callDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateSite} opts.createSite Payload for creating a new site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "createWithHttpInfo",
    value: function createWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['createSite'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateSite} opts.createSite Payload for creating a new site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "create",
    value: function create(opts) {
      return this.createWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/CreatePopulation} opts.createPopulation Payload for creating a new population for a site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "createPopulationWithHttpInfo",
    value: function createPopulationWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['createPopulation'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling createPopulation");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/population', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/CreatePopulation} opts.createPopulation Payload for creating a new population for a site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "createPopulation",
    value: function createPopulation(id, opts) {
      return this.createPopulationWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateSavingsGuarantee} opts.createSavingsGuarantee Payload for creating a new savings guarantee for a site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "createSavingsGuaranteeWithHttpInfo",
    value: function createSavingsGuaranteeWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['createSavingsGuarantee'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling createSavingsGuarantee");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/savings-guarantee', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateSavingsGuarantee} opts.createSavingsGuarantee Payload for creating a new savings guarantee for a site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "createSavingsGuarantee",
    value: function createSavingsGuarantee(id, opts) {
      return this.createSavingsGuaranteeWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id ID of the site.
     * @param {String} startDate Start date of the population in yyyy-mm-dd format.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "deletePopulationWithHttpInfo",
    value: function deletePopulationWithHttpInfo(id, startDate) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deletePopulation");
      }
      // verify the required parameter 'startDate' is set
      if (startDate === undefined || startDate === null) {
        throw new Error("Missing the required parameter 'startDate' when calling deletePopulation");
      }
      var pathParams = {
        'id': id,
        'startDate': startDate
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/population/{startDate}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id ID of the site.
     * @param {String} startDate Start date of the population in yyyy-mm-dd format.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "deletePopulation",
    value: function deletePopulation(id, startDate) {
      return this.deletePopulationWithHttpInfo(id, startDate).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
     * @param {String} opts.customAttributes IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getWithHttpInfo",
    value: function getWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling get");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'timezone': opts['timezone'],
        'customAttributes': opts['customAttributes']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
     * @param {String} opts.customAttributes IANA timezone of the caller to determine the contextual current day. Defaults to Australia/Brisbane
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "get",
    value: function get(id, opts) {
      return this.getWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {String} opts.aggregation Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
     * @param {String} opts.grouping Grouping of the submeters breakdown; type, group or none; default: none.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getEnergyBreakdownWithHttpInfo",
    value: function getEnergyBreakdownWithHttpInfo(id, start, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getEnergyBreakdown");
      }
      // verify the required parameter 'start' is set
      if (start === undefined || start === null) {
        throw new Error("Missing the required parameter 'start' when calling getEnergyBreakdown");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'start': start,
        'end': opts['end'],
        'aggregation': opts['aggregation'],
        'grouping': opts['grouping']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/energy/breakdown', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {String} opts.aggregation Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
     * @param {String} opts.grouping Grouping of the submeters breakdown; type, group or none; default: none.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getEnergyBreakdown",
    value: function getEnergyBreakdown(id, start, opts) {
      return this.getEnergyBreakdownWithHttpInfo(id, start, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {String} opts.aggregation Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getEnergyDataFeedWithHttpInfo",
    value: function getEnergyDataFeedWithHttpInfo(id, start, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getEnergyDataFeed");
      }
      // verify the required parameter 'start' is set
      if (start === undefined || start === null) {
        throw new Error("Missing the required parameter 'start' when calling getEnergyDataFeed");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'start': start,
        'end': opts['end'],
        'aggregation': opts['aggregation']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/energy/data-feed', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {String} opts.aggregation Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getEnergyDataFeed",
    value: function getEnergyDataFeed(id, start, opts) {
      return this.getEnergyDataFeedWithHttpInfo(id, start, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getEnergyLifetimeDataWithHttpInfo",
    value: function getEnergyLifetimeDataWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getEnergyLifetimeData");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/energy/lifetime-data', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getEnergyLifetimeData",
    value: function getEnergyLifetimeData(id) {
      return this.getEnergyLifetimeDataWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getMetersWithHttpInfo",
    value: function getMetersWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getMeters");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/meters', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getMeters",
    value: function getMeters(id) {
      return this.getMetersWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.utility Utility type of the meter.
     * @param {Array.<Number>} opts.types Filter of the type of the physical meter.
     * @param {Array.<Number>} opts.excludeTypes Filter of the types of the physical meter to exclude.
     * @param {Number} opts.status Filter of the status of the physical meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getPhysicalMetersWithHttpInfo",
    value: function getPhysicalMetersWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getPhysicalMeters");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'utility': opts['utility'],
        'types': this.apiClient.buildCollectionParam(opts['types'], 'multi'),
        'excludeTypes': this.apiClient.buildCollectionParam(opts['excludeTypes'], 'multi'),
        'status': opts['status']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/meters/physical', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.utility Utility type of the meter.
     * @param {Array.<Number>} opts.types Filter of the type of the physical meter.
     * @param {Array.<Number>} opts.excludeTypes Filter of the types of the physical meter to exclude.
     * @param {Number} opts.status Filter of the status of the physical meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getPhysicalMeters",
    value: function getPhysicalMeters(id, opts) {
      return this.getPhysicalMetersWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date in the site's timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getPopulationWithHttpInfo",
    value: function getPopulationWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getPopulation");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'date': opts['date']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/population', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date in the site's timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getPopulation",
    value: function getPopulation(id, opts) {
      return this.getPopulationWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date in the site's timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSavingsGuaranteeWithHttpInfo",
    value: function getSavingsGuaranteeWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSavingsGuarantee");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'date': opts['date']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/savings-guarantee', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date in the site's timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSavingsGuarantee",
    value: function getSavingsGuarantee(id, opts) {
      return this.getSavingsGuaranteeWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date in the site's timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSavingsGuaranteeDailyFeedWithHttpInfo",
    value: function getSavingsGuaranteeDailyFeedWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSavingsGuaranteeDailyFeed");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'date': opts['date']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/savings-guarantee/feed/daily', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date in the site's timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSavingsGuaranteeDailyFeed",
    value: function getSavingsGuaranteeDailyFeed(id, opts) {
      return this.getSavingsGuaranteeDailyFeedWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date in the site's timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSavingsGuaranteeFeedWithHttpInfo",
    value: function getSavingsGuaranteeFeedWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSavingsGuaranteeFeed");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'date': opts['date']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/savings-guarantee/feed', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date in the site's timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSavingsGuaranteeFeed",
    value: function getSavingsGuaranteeFeed(id, opts) {
      return this.getSavingsGuaranteeFeedWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone The end-users IANA timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSummaryWithHttpInfo",
    value: function getSummaryWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSummary");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'timezone': opts['timezone']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiKey', 'ApiSoftAuthorizer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/summary', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.timezone The end-users IANA timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSummary",
    value: function getSummary(id, opts) {
      return this.getSummaryWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Array.<Number>} opts.type List of note types to filter by.
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {String} opts.order Ordering fo the results; asc or desc.
     * @param {String} opts.orderBy Column to order the results by; eventDate, id, resourceType, or created.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSupportNotesWithHttpInfo",
    value: function getSupportNotesWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSupportNotes");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'type': this.apiClient.buildCollectionParam(opts['type'], 'multi'),
        'page': opts['page'],
        'limit': opts['limit'],
        'order': opts['order'],
        'orderBy': opts['orderBy']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/support-notes', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Array.<Number>} opts.type List of note types to filter by.
     * @param {Number} opts.page Page of results to return.
     * @param {Number} opts.limit Limit of results to return.
     * @param {String} opts.order Ordering fo the results; asc or desc.
     * @param {String} opts.orderBy Column to order the results by; eventDate, id, resourceType, or created.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSupportNotes",
    value: function getSupportNotes(id, opts) {
      return this.getSupportNotesWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSystemsWithHttpInfo",
    value: function getSystemsWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSystems");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/systems', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSystems",
    value: function getSystems(id) {
      return this.getSystemsWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Boolean} opts.includeDisabled Include disabled virtual meter data sources.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSystemsDataFeedWithHttpInfo",
    value: function getSystemsDataFeedWithHttpInfo(id, start, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getSystemsDataFeed");
      }
      // verify the required parameter 'start' is set
      if (start === undefined || start === null) {
        throw new Error("Missing the required parameter 'start' when calling getSystemsDataFeed");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'start': start,
        'end': opts['end'],
        'includeDisabled': opts['includeDisabled']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/systems/data-feed', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Boolean} opts.includeDisabled Include disabled virtual meter data sources.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSystemsDataFeed",
    value: function getSystemsDataFeed(id, start, opts) {
      return this.getSystemsDataFeedWithHttpInfo(id, start, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.parentId ID of the parent.
     * @param {Array.<Number>} opts.types Filter of the type of the virtual meter.
     * @param {Array.<Number>} opts.excludeTypes Filter of the types of the virtual meter to exclude.
     * @param {Array.<String>} opts.nodeTypes Type of nodes to match: grid, generator or battery.
     * @param {Array.<String>} opts.excludeNodeTypes Type of nodes to not match: grid, generator or battery.
     * @param {Number} opts.status Filter of the status of the virtual meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getVirtualMetersWithHttpInfo",
    value: function getVirtualMetersWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVirtualMeters");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'parentId': opts['parentId'],
        'types': this.apiClient.buildCollectionParam(opts['types'], 'multi'),
        'excludeTypes': this.apiClient.buildCollectionParam(opts['excludeTypes'], 'multi'),
        'nodeTypes': this.apiClient.buildCollectionParam(opts['nodeTypes'], 'multi'),
        'excludeNodeTypes': this.apiClient.buildCollectionParam(opts['excludeNodeTypes'], 'multi'),
        'status': opts['status']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/meters/virtual', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.parentId ID of the parent.
     * @param {Array.<Number>} opts.types Filter of the type of the virtual meter.
     * @param {Array.<Number>} opts.excludeTypes Filter of the types of the virtual meter to exclude.
     * @param {Array.<String>} opts.nodeTypes Type of nodes to match: grid, generator or battery.
     * @param {Array.<String>} opts.excludeNodeTypes Type of nodes to not match: grid, generator or battery.
     * @param {Number} opts.status Filter of the status of the virtual meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getVirtualMeters",
    value: function getVirtualMeters(id, opts) {
      return this.getVirtualMetersWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.date The requested date for the weather.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getWeatherWithHttpInfo",
    value: function getWeatherWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getWeather");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'date': opts['date']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/weather', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.date The requested date for the weather.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getWeather",
    value: function getWeather(id, opts) {
      return this.getWeatherWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.range Range of records to select; future, past or all.
     * @param {String} opts.order Direction of the ordering; asc or desc - defaults to asc.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "listPopulationWithHttpInfo",
    value: function listPopulationWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling listPopulation");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'range': opts['range'],
        'order': opts['order']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/population/list', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.range Range of records to select; future, past or all.
     * @param {String} opts.order Direction of the ordering; asc or desc - defaults to asc.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "listPopulation",
    value: function listPopulation(id, opts) {
      return this.listPopulationWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateSite} opts.updateSite Payload for updating an existing site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "updateWithHttpInfo",
    value: function updateWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['updateSite'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling update");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateSite} opts.updateSite Payload for updating an existing site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "update",
    value: function update(id, opts) {
      return this.updateWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id ID of the site.
     * @param {String} startDate Start date of the population in yyyy-mm-dd format.
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdatePopulation} opts.updatePopulation Payload for updating a new population for a site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "updatePopulationWithHttpInfo",
    value: function updatePopulationWithHttpInfo(id, startDate, opts) {
      opts = opts || {};
      var postBody = opts['updatePopulation'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updatePopulation");
      }
      // verify the required parameter 'startDate' is set
      if (startDate === undefined || startDate === null) {
        throw new Error("Missing the required parameter 'startDate' when calling updatePopulation");
      }
      var pathParams = {
        'id': id,
        'startDate': startDate
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/population/{startDate}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id ID of the site.
     * @param {String} startDate Start date of the population in yyyy-mm-dd format.
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdatePopulation} opts.updatePopulation Payload for updating a new population for a site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "updatePopulation",
    value: function updatePopulation(id, startDate, opts) {
      return this.updatePopulationWithHttpInfo(id, startDate, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id ID of the site.
     * @param {String} startDate Start date of the savings guarantee in yyyy-mm-dd format.
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateSavingsGuarantee} opts.updateSavingsGuarantee Payload for creating a new savings guarantee for a site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "updateSavingsGuaranteeWithHttpInfo",
    value: function updateSavingsGuaranteeWithHttpInfo(id, startDate, opts) {
      opts = opts || {};
      var postBody = opts['updateSavingsGuarantee'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateSavingsGuarantee");
      }
      // verify the required parameter 'startDate' is set
      if (startDate === undefined || startDate === null) {
        throw new Error("Missing the required parameter 'startDate' when calling updateSavingsGuarantee");
      }
      var pathParams = {
        'id': id,
        'startDate': startDate
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/sites/{id}/savings-guarantee/{startDate}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id ID of the site.
     * @param {String} startDate Start date of the savings guarantee in yyyy-mm-dd format.
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateSavingsGuarantee} opts.updateSavingsGuarantee Payload for creating a new savings guarantee for a site.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "updateSavingsGuarantee",
    value: function updateSavingsGuarantee(id, startDate, opts) {
      return this.updateSavingsGuaranteeWithHttpInfo(id, startDate, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return SitesApi;
}();
exports["default"] = SitesApi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/api-sdk/dist/api/SitesApi.js
// module id = a7Hr
// module chunks = 22